import  { useState,} from "react";

import { Box, Card, Grid, FormLabel, Divider, RadioGroup, Autocomplete, FormControlLabel, Radio, Typography, Button, Tooltip, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import Searchicon from '@mui/icons-material/Search';

import { useRef } from "react";

import CallAlertBar from "../../../Layout/Alertbar";
import 'dayjs/plugin/customParseFormat';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { tokens } from "../../../theme/theme";
import SearchIcon from '@mui/icons-material/Search';
import GlobalConfig from "../../../config/date/GlobalConfig";
import * as XLSX from "xlsx";

import PrintPreviewReamBundleConvertionRpt from "./PrintPreviewReamBundle";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
const ReamBundlePendingConversionReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [partyList, setPartyList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    // Fallback colors in case tokens are undefined
    const primaryColor = colors?.primary?.[500] || '#1976d2';  // Default blue if undefined
    const secondaryColor = colors?.secondary?.[500] || '#5293fa';  // Default red if undefined


    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [open, setOpen] = useState(false);
    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };

    const [indentno, setIndentno] = useState('');
    const [batchno, setBatchno] = useState('');

    const [lineno, setlineno] = useState(0);
    const callbackPdf = () => {

        setViewReport(false);
    }



    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });
    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });






    //////////////////////////////////////////////////////////////////////////////////////////////
    const [selectedOption, setSelectedOption] = useState('order'); // Default to "Order"


    const [viewReport, setViewReport] = useState(false);
    const [parentRoll, setparentRoll] = useState([]);

    const reportRef = useRef();





    const getReportData = () => {

        let parameters = {
            p_indent_no: indentno,
            p_line_no: lineno,
        };

        callApi(API_ENDPOINTS.REPORT_GetProductionOrderWiseReamAndBundlePendingConversionDet, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                if (data.length > 0) {
                    setPartyList(data);
                    setViewReport(true);
                }
                else {
                    setPartyList([]);
                    setViewReport(false);
                    alert('No pending ream bundle details found!')
                }
            })
            .catch(error => {
                alert(error);
            });

    };

    const btnSearchOrderWisePendingReelDet = (e) => {

        if (indentno === '') {

            alert('Please enter order details for search');
            return;
        }

        getReportData();

    }

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleExportToExcel = () => {
        // Get today's date in dd-mm-yyyy format
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = now.getFullYear();
        const todayDate = `${day}-${month}-${year}`;

        // Define custom header rows with dynamic data
        const customHeader = [
            [
                `DATE :-`, todayDate, "", `Cutting to Finishing`, "", "", "", "", "", ""
            ],
            [
                `PLANING NO :-`, "", `PO NO :- ${indentno}-${lineno},`,
                `QUALITY :- ${partyList[0]?.item_code || "N/A"},`, `GSM :- ${partyList[0]?.gsm || "N/A"}`, `SIZE :- ${partyList[0]?.size || "N/A"}`, "", "", "", "", 
            ],
            [
                "SR NO", "ROLL NO", "REEL NO", "F.NO REAM", "REAM TOTAL", "BUNDLE TOTAL",
                "REMARK", "LOCATION"
            ]
        ];

        // Prepare the data with headers
        const formattedData = partyList.map(row => ([
            row.id,
            row.pr_number,
            row.child_reel_number,
            '', // F.NO REAM
            '', // REAM TOTAL
            '', // BUNDLE TOTAL
            '', // REMARK
            '', // LOCATION      
        ]));

        // Combine header and data
        const combinedData = [...customHeader, ...formattedData];

        // Create a new worksheet with the combined data
        const worksheet = XLSX.utils.aoa_to_sheet(combinedData);

        // Apply styles for the first row (header)
        const headerStyle = { font: { bold: true, sz: 16 }, alignment: { horizontal: "center" } };
        const subHeaderStyle = { font: { bold: true, sz: 12 }, alignment: { horizontal: "center" } };

        // Apply styles for the first header row
        for (let col = 0; col < customHeader[0].length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: col }); // First row, columns
            if (worksheet[cellRef]) worksheet[cellRef].s = headerStyle;
        }

        // Apply styles for the second header row
        for (let col = 0; col < customHeader[1].length; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: 1, c: col }); // Second row, columns
            if (worksheet[cellRef]) worksheet[cellRef].s = subHeaderStyle;
        }

        // Set column widths
        worksheet['!cols'] = [
            { wch: 15 }, // SR NO
            { wch: 15 }, // ROLL NO
            { wch: 20 }, // REEL NO.
            { wch: 25 }, // F.NO REAM
            { wch: 15 }, // REAM TOTAL
            { wch: 15 }, // BUNDLE TOTAL
            { wch: 15 }, // REMARK
            { wch: 15 }, // LOCATION
       
        ];

        // Create a workbook and append the styled worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Ream Bundle Pending");

        // Format filename as ddmmyyyy_HHMM
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const dateTime = `${day}${month}${year}_${hours}${minutes}`;
        const fileName = `Order Wise Ream and Bundle Pending Conversion Report.xlsx`;

        // Export the file
        XLSX.writeFile(workbook, fileName);
    };



    return (

        <Box style={{ backgroundColor: "transparent", height: '620px' }}>
            <Box style={{ backgroundColor: "#0277bd" }} flexDirection={'row'} p={'5px'}>
                <ReportsHeader title={'Order Wise Ream/Bundle Pending Conversion Report'} subtitle="" callback={handleBackWinderMachineEntry} />
            </Box>

            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


            <CardContent sx={{ border: "1px solid #3d3d3d" }}>
                <Box display="flex" flexDirection={'column'}>
                    <Box m='0px' display="flex" justifyContent={'space-between'}>
                        <Grid container spacing={1} justifyContent="space-between" style={{ marginTop: '0px' }}>
                            <Box m='0px' display="flex" justifyContent={'start'}>
                                <Typography ml={0} style={{ marginTop: '7px', marginLeft: '6px', marginRight: '10px', fontSize: '14px' }}> Filter Input : </Typography>

                                {selectedOption === 'order' ? (
                                    <>
                                        <TextField
                                            label="CO No."
                                            value={indentno}
                                            variant="outlined"
                                            onChange={(e) => setIndentno(e.target.value)} // Handle input changes
                                            size="small"
                                            sx={{ marginRight: 0.5 }} // Add some margin to the right for spacing
                                        />

                                     
                                     

                                    </>
                                ) : (
                                    <TextField
                                        label="Batch Number"
                                        value={batchno}
                                        onChange={(e) => setBatchno(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        sx={{ marginRight: 1 }} // Add some margin to the right for spacing
                                    />
                                )}

                                <IconButton  >
                                    <SearchIcon onClick={btnSearchOrderWisePendingReelDet} />
                                </IconButton>




                            </Box>

                            {viewReport && (
                                <Tooltip title="Download Report" >
                                    <IconButton onClick={handleExportToExcel}>
                                        <FileDownloadIcon style={{ color: "#1de9b6" }} />
                                    </IconButton>
                                </Tooltip>)}
                        </Grid>
                    </Box>



                </Box>

                {viewReport && (
                    <Box
                        gridColumn="span 9"
                        gridRow={"span 2"}
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                // fontWeight: "bold",
                                border: "1px solid ",
                                borderColor: `${colors.primary[400]} !important`,
                            },
                            "& .name-column--cell": {
                                color: colors.greenAccent[300],
                            },
                            "& .MuiTableHead-root": {
                                // backgroundColor: colors.blueAccent[700],
                                borderBottom: "none",

                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                            // backgroundColor: colors.primary[700],
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '65vh', // Large devices (desktops)
                                xl: '86vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling

                            maxWidth: {
                                xs: '110vh', // Extra small devices (phones)
                                sm: '120vh', // Small devices (tablets)
                                md: '130vh', // Medium devices (small laptops)
                                lg: '145vh', // Large devices (desktops)
                                xl: '145vh', // Extra large devices (large desktops)
                            },
                            overflowX: 'auto',

                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }

                        }}>


                        <TableContainer >
                            <Table stickyHeader size="small" >
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>

                                        <TableCell></TableCell>

                                        <TableCell>ROLL NO</TableCell>
                                        <TableCell>REEL NO</TableCell>
                                        <TableCell>F.NO REAM </TableCell>
                                        <TableCell>REAM TOTAL </TableCell>
                                        <TableCell>BUNDLE TOTAL </TableCell>                                
                                        <TableCell> REMARKS</TableCell>
                                        <TableCell> LOCATION</TableCell>


                                        <TableCell>
                                            <IconButton onClick={handleOpen}>
                                                <Searchicon style={{ fontSize: "16px" }} />
                                            </IconButton>
                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                    <TextField
                                                        label="Parent Roll Number"
                                                        name="pr_number"
                                                        value={filters.pr_number}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                    />
                                                    <TextField
                                                        label="Child Reel Number"
                                                        name="child_reel_number"
                                                        value={filters.child_reel_number}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        size="small"
                                                    />



                                                    <Button variant="contained" style={{ marginTop: 10 }}>
                                                        {/* onClick={handleClose} */}
                                                        Apply Filter
                                                    </Button>
                                                </Box>
                                            </Modal>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row) => (
                                        <TableRow key={row.id}>


                                            <TableCell>{row.id}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.child_reel_number}</TableCell>
                                        


                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </Box>
                )}


                {viewReport && (
                <PrintPreviewReamBundleConvertionRpt parentRollDetails={partyList} cono={indentno} />
          
            )}


            </CardContent>
        </Box>

    )
};
export default ReamBundlePendingConversionReport;